import React from 'react';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const NewsCard = ({ image, title, date, link }) => {
  return (
    <Link to={link} style={{ textDecoration: 'none' }}>
      <Card sx={{ width: 345, margin: '20px', height: '100%' }}> {/* Set fixed width and height */}
        <CardMedia
          component="img"
          alt={title}
          image={image}
          sx={{
            cursor: 'pointer',
            width: '100%',       // Ensure the image takes up full width of the card
            height: 'auto',      // Maintain aspect ratio of the image
            objectFit: 'contain',  // Ensures the entire image is visible without cropping
          }}
        />
        <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', backgroundColor:'#000000' }}>
          <Typography gutterBottom variant="h5"  component="div">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {date}
          </Typography>
        </CardContent>
      </Card>
    </Link>
  );
};

export default NewsCard;
